var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "igc-label", style: { background: _vm.mColor(7) } },
    [
      _c(
        "sui-scroll",
        {
          staticClass: "ig--detail",
          style: { background: _vm.mBackground(17, "right") }
        },
        [
          _c("sui-image", {
            staticClass: "ig--poster",
            attrs: { src: _vm.imagePath + "/poster/" + _vm.label + ".png" }
          }),
          _c("div", { staticClass: "ig--info" }, [
            _c(
              "div",
              { staticClass: "ig--name", style: { color: _vm.mColor(1) } },
              [_vm._v(_vm._s(_vm.knowledge.name))]
            ),
            _c(
              "div",
              { staticClass: "ig--desc", style: { color: _vm.mColor(3) } },
              [_vm._v(_vm._s(_vm._f("changeEnter")(_vm.knowledge.desc)))]
            ),
            _c(
              "div",
              { staticClass: "ig--link" },
              _vm._l(_vm.knowledge.url, function(item) {
                return _c(
                  "div",
                  {
                    key: item.url,
                    staticClass: "item",
                    style: {
                      color: _vm.mColor(4),
                      "border-color": _vm.mColor(4)
                    },
                    on: {
                      click: function($event) {
                        return _vm.to(item.url)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name) + " >")]
                )
              }),
              0
            )
          ])
        ],
        1
      ),
      _vm.knowledge.items
        ? _c(
            "div",
            { staticClass: "ig--playbook" },
            [
              _c(
                "div",
                {
                  staticClass: "ig--tab",
                  style: { background: _vm.mBackground(17, "bottom") }
                },
                _vm._l(_vm.knowledge.items, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: item.name,
                      staticClass: "ig--item",
                      style: {
                        color:
                          _vm.tab == index ? _vm.mColor(14) : _vm.mColor(15)
                      },
                      on: {
                        touchstart: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleTab(item, index)
                        }
                      }
                    },
                    [
                      _c("div", [_vm._v(_vm._s(item.name))]),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.tab == index,
                            expression: "tab == index"
                          }
                        ],
                        staticClass: "ig--active",
                        style: { "background-color": _vm.mColor(14) }
                      })
                    ]
                  )
                }),
                0
              ),
              _c(
                "sui-scroll",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.knowledge.items[_vm.tab] &&
                        _vm.knowledge.items[_vm.tab].type == 1,
                      expression:
                        "knowledge.items[tab] && knowledge.items[tab].type == 1"
                    }
                  ],
                  staticClass: "ig--list",
                  on: { reachEnd: _vm.getV4List }
                },
                [
                  _c("div", { staticClass: "ig--title" }, [
                    _c("div", { style: { color: _vm.mColor(3) } }, [
                      _vm._v("共有 " + _vm._s(_vm.total) + " 条精品攻略")
                    ])
                  ]),
                  _vm._l(_vm.v4List, function(item) {
                    return _c("igc-item-playbook", {
                      key: item.iId,
                      attrs: { playbook: item }
                    })
                  }),
                  _c("sui-load", {
                    attrs: { color: _vm.mColor(3), more: _vm.more }
                  })
                ],
                2
              ),
              _c(
                "sui-scroll",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.knowledge.items[_vm.tab] &&
                        _vm.knowledge.items[_vm.tab].type == 2,
                      expression:
                        "knowledge.items[tab] && knowledge.items[tab].type == 2"
                    }
                  ],
                  staticClass: "ig--list",
                  on: { reachEnd: _vm.getUGCList }
                },
                [
                  _c("div", { staticClass: "ig--title" }, [
                    _c("div", { style: { color: _vm.mColor(3) } }, [
                      _vm._v("共有 " + _vm._s(_vm.totalUGC) + " 条短攻略")
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "ig--sort",
                        style: { color: _vm.mColor(4) },
                        on: {
                          touchstart: function($event) {
                            _vm.sortUGC = _vm.sortUGC == 1 ? 2 : 1
                          }
                        }
                      },
                      [
                        _c("div", [
                          _vm._v(
                            _vm._s(_vm.sortUGC == 1 ? "时间" : "热门") + "排序"
                          )
                        ]),
                        _c("sui-icon", {
                          staticClass: "ig--icon",
                          attrs: { name: "sort", fill: _vm.mColor(4) }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._l(_vm.UGCList, function(item, index) {
                    return _c("igc-item-short", {
                      key: item.guide_id,
                      attrs: { item: item, notag: true },
                      on: {
                        "delete-item": function($event) {
                          return _vm.deleteMoment(index)
                        }
                      }
                    })
                  }),
                  _c("sui-load", {
                    attrs: { color: _vm.mColor(3), more: _vm.moreUGC }
                  })
                ],
                2
              ),
              _c(
                "sui-scroll",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.knowledge.items[_vm.tab] &&
                        _vm.knowledge.items[_vm.tab].type == 3,
                      expression:
                        "knowledge.items[tab] && knowledge.items[tab].type == 3"
                    }
                  ],
                  staticClass: "ig--list"
                },
                [
                  _c("iframe", {
                    attrs: {
                      frameborder: "0",
                      src: _vm.mAddTokenParams(_vm.knowledge.items[_vm.tab].url)
                    }
                  })
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _c("igc-submit-entry", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.knowledge.items &&
              _vm.knowledge.items[_vm.tab] &&
              _vm.knowledge.items[_vm.tab].type == 2,
            expression:
              "knowledge.items && knowledge.items[tab] && knowledge.items[tab].type == 2"
          }
        ],
        attrs: { id: _vm.label }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }